import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'bi-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
  standalone: false
})
export class PageNotFoundComponent {

  constructor(private location: Location) { }

  /**
   * Navigate back to the previous page
   */
  goBack(): void {
    this.location.back();
  }
}
